// extracted by mini-css-extract-plugin
export default {"root":"classes_root__nJUkd","title":"classes_title__bac3M","subtitle":"classes_subtitle__2C42b","container":"classes_container__DFASY","button":"classes_button__cg2od"};